import { useEffect, useRef } from 'react';
import { CarouselImperativeHandle } from '../components/Carousel';

export const useCarouselKeyboardNavigation = (
  enabled: boolean,
  containerRef?: React.RefObject<HTMLElement | null>
) => {
  const carouselRef = useRef<CarouselImperativeHandle>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
        return;
      }

      const activeElement = document.activeElement;

      if (
        activeElement &&
        (activeElement.tagName === 'INPUT' ||
          activeElement.tagName === 'TEXTAREA' ||
          activeElement.getAttribute('contenteditable') === 'true' ||
          (activeElement instanceof HTMLElement &&
            activeElement.isContentEditable))
      ) {
        return;
      }

      if (containerRef?.current) {
        const container = containerRef.current;
        const isContainerVisible = container.offsetParent !== null;

        if (!isContainerVisible) {
          return;
        }

        const carouselDialog =
          container.closest('[role="dialog"]') || container.closest('dialog');

        if (activeElement && carouselDialog) {
          const activeDialog =
            activeElement.closest('[role="dialog"]') ||
            activeElement.closest('dialog');

          if (activeDialog && activeDialog !== carouselDialog) {
            return;
          }
        }

        const isInDialog =
          carouselDialog && carouselDialog.contains(activeElement);
        const isInContainer = container.contains(activeElement);

        if (isInContainer || isInDialog) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            carouselRef.current?.scrollPrev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            carouselRef.current?.scrollNext();
          }
        }
      } else {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          carouselRef.current?.scrollPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          carouselRef.current?.scrollNext();
        }
      }
    };

    if (enabled) {
      window.addEventListener('keydown', handleKeyDown, true);
      return () => {
        window.removeEventListener('keydown', handleKeyDown, true);
      };
    }
  }, [enabled, containerRef]);

  return carouselRef;
};
